export interface TrainingSchedule {
  id: number | null;
  name: string;
  startDate: string;
  endDate: string;
  active: boolean;
  canceledDays: string[];
}

export const trainingScheduleInit: TrainingSchedule = {
  id: null,
  name: "",
  startDate: "",
  endDate: "",
  active: false,
  canceledDays: [],
};
